import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const isPlainObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value)

const textareaStyle = {
  width: '100%',
  fontFamily: 'monospace',
  fontSize: 'var(--font-size-xs)',
  padding: '8px',
  border: '1px solid var(--color-neutral-200)',
  borderRadius: '4px',
  resize: 'vertical',
  minHeight: '80px'
}

function JsonField ({ value, onChange, placeholder, rows, expectObject }) {
  const [text, setText] = useState(value == null ? '' : JSON.stringify(value, null, 2))
  const [parseError, setParseError] = useState(null)

  useEffect(() => {
    setText(value == null ? '' : JSON.stringify(value, null, 2))
  }, [value])

  const handleChange = (e) => {
    const next = e.target.value
    setText(next)
    if (!next.trim()) {
      setParseError(null)
      onChange(null)
      return
    }
    try {
      const parsed = JSON.parse(next)
      if (expectObject && !isPlainObject(parsed)) {
        setParseError('Value must be a JSON object (e.g. { "key": "value" })')
        return
      }
      setParseError(null)
      onChange(parsed)
    } catch (err) {
      setParseError(err.message)
    }
  }

  return (
    <div>
      <textarea
        value={text}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows ?? 4}
        style={textareaStyle}
      />
      {parseError ? (
        <div style={{ color: 'var(--color-decline-500)', fontSize: 'var(--font-size-xxs, 0.625rem)', marginTop: '2px' }}>
          {parseError}
        </div>
      ) : null}
    </div>
  )
}

JsonField.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  expectObject: PropTypes.bool
}

export default JsonField
